<template>
  <div id="app">
    <!-- <Calculator /> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import Calculator from './components/MyCalculator.vue';

export default {
  name: 'App',
  // components: {
  //   Calculator
  // }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  /* margin-top: 60px; */
}
</style>